import { render, staticRenderFns } from "./DeleteRepairSetting.vue?vue&type=template&id=5dd96863"
import script from "./DeleteRepairSetting.vue?vue&type=script&lang=js"
export * from "./DeleteRepairSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports